import { runAxios, runAxiosAsync } from '../../handlers/axios';
import { onLink, onSubmit, save } from '../../handlers';
import { updateSectionData } from '../../handlers/utils';
import { devNull, getUsefulVars } from '../../handlers/helpers';
import { composeBullet } from '../../components/Preview/utils';

export const skipParse = (stateProps) => {
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const resume = stateProps.dataToSave.saved.resumes[resumeIndex];
  resume.parsed = true;
  updateSectionData({
    parsed: resume.parsed,
    sectionName: 'menu',
  }, stateProps);
};

const sendFailedParseEmail = (props, status) => {
  const url = props.stateProps.domain + '/wp-json/rsworks/v1/failedParse';
  const request = {
    status: status,
  };
  const args = {
    props: props,
    status: status,
  };
  runAxios(url, request, devNull, args);
};

const pollForParseCallback = (result, args) => {
  const maxAttempts = 20;

  switch (result.data.status) {
    case 'completed':
      parseResumePollCallback(result.data.resume, args);
      return;

    case 'failed':
      handleParseError(result.data.error || 'Parse job failed', args);
      return;

    default:
      if (args.attempts >= maxAttempts) {
        handleParseError('Parse request timed out', args);
        return;
      }

      const dots = '●'.repeat(Math.min(args.attempts, 10)); // Cap at 10 dots
      const message = `Parsing resume... ${dots}`;
      args.props.stateProps.setSpinnerMessage(message);

      // Continue polling
      setTimeout(() => args.poll(args), 2000);
  }
};

/**
 *
 * @param jobId
 * @param userID
 * @param args
 * @param maxAttempts
 * @param interval
 * @returns {(function(): void)|*}
 */
function pollForParseResult(jobId, userID, args) {
  let timeoutId = null;
  const poll = async (args) => {
    args.attempts++;
    try {
      const uv = getUsefulVars(args.props);

      const target_industry = uv.resume['industry'][0];
      const target_role = uv.resume['job_title'];
      const resumeIndex = uv.stateProps.sectionData.resumeIndex;
      const url = `${uv.stateProps.domain}/wp-json/rsworks/v1/check-parse-status`;
      const request = {
        resume_index: resumeIndex,
        userID: args.userID,
        jobID: args.jobID,
        target_industry: target_industry,
        target_role: target_role,
      };
      runAxios(url, request, pollForParseCallback, args);
    } catch (error) {
      handleParseError('Polling failed: ' + error.message, args);
    }
  };
  args.attempts=1;
  args.poll = (pollArgs) => {
    timeoutId = setTimeout(() => poll(pollArgs), 2000);
  };
  poll(args);

  // Return cleanup function
  return () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
}
const cleanupFileUploadError = (fileUpload,args,message) => {
  if(fileUpload) {
    fileUpload.value = '';
  }
  sendFailedParseEmail(args.props, message);
  args.props.stateProps.setSpinnerImage('');
  args.props.stateProps.setSpinnerMessage('');
  args.props.stateProps.onSpinnerClose();
}
export const handleFileUploadError =(result,stateProps,args) => {

  const fileUpload = document.getElementById('jobSeekerData[0]["P2"]');
  if (result.error === 'invalid file type') {
    alert('The parser upload supports only PDF and DOCX files. Please try again.');
    cleanupFileUploadError(fileUpload,args,'badMeta');
    return true;
  }
  if (result.error === 'blank upload') {
    alert('You uploaded a blank file.  Please try again');
    cleanupFileUploadError(fileUpload,args,'blankFail');
    return true;
  }
  if (result.error === 'too large') {
    alert('This resume is too long. Please upload a resume that\'s under two pages, or less than 10,000 characters');
    cleanupFileUploadError(fileUpload,args,'tooLarge');
    return true;
  }
  if (result.error === 'PortKey job failed') {
    alert('The parsing of this resume timed out. Please try again later.');
    cleanupFileUploadError(fileUpload,args,'parseFail');
    return true;
  }
  return false;
}
/**
 *
 * @param errorMessage
 * @param args
 * @param errorType
 */
function handleParseError(errorMessage, args, errorType = 'unknown') {
  const props = args.props;
  const stateProps = props.stateProps;
  const savedResumes = props.formikProps.values.jobSeekerData[0];
  const fileUpload = document.getElementById('jobSeekerData[0]["P2"]');

  if (fileUpload) {
    fileUpload.value = '';
  }
  if (savedResumes?.P2) {
    savedResumes.P2.value = '';
  }

  const errorStatus = getErrorStatus(errorType, errorMessage);
  sendFailedParseEmail(args.props, errorStatus);

  stateProps.setSpinnerImage('');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
}

function getErrorStatus(errorType, errorMessage) {
  if (errorMessage.includes('timeout')) return 'timeout';
  if (errorMessage.includes('network')) return 'networkError';
  if (errorType === 'polling') return 'pollingFail';
  return 'asyncParseFail ' + errorType + ' ' + 'message: ' + errorMessage;
}

const parseLetterCallback = (result, args) => {
  const uv = getUsefulVars(args.props);
  const resumes = uv.stateProps.dataToSave.saved.resumes;

  if (uv.resume['parse-letter'] === undefined) {
    uv.resume['parse-letter'] = [];
    uv.resume['parse-letter'][0] = {};
  }
  uv.resume['parse-letter'][0]['PL6'] = result.data;
  const newData = { resumes: resumes };
  uv.stateProps.setDataToSave({ saved: newData, industry: uv.stateProps.dataToSave.industry });
  uv.stateProps.setSpinnerImage('');
  uv.stateProps.setSpinnerMessage('');
  uv.stateProps.onSpinnerClose();
  save(uv.stateProps, uv.resumeIndex);
  onLink(false, uv.formikProps, uv.stateProps, 'preview-letter');
};
const parseResumeCallback = (result, args) => {
  const jobID = result.job_id;
  const userID = result.user_id;
  if (result.status === 'completed') {
    parseResumePollCallback(result.result , args);
  } else {
    pollForParseResult(jobID, userID, args);
    const cleanupUrl = `${args.props.stateProps.domain}/wp-json/rsworks/v1/cleanup-parse-job`;
    const cleanupRequest = {
      userID: userID,
      jobID: jobID,
    };
    runAxios(cleanupUrl, cleanupRequest, devNull, {});
  }
}

const parseResumePollCallback = (result, args) => {
  const savedResumes = args.props.formikProps.values.jobSeekerData[0];
  savedResumes.P2.value = '';
  const props = args.props;
  const stateProps = props.stateProps;


  const resumeIndex = stateProps.sectionData.resumeIndex;
  const resumes = stateProps.dataToSave.saved.resumes;
  //bah
  const resume = result.data ? result.data.resume: result.resume;
  resumes[resumeIndex] = resume;
  resume.parsed = true;

  for (const experience of resume['professional-experience']) {
    experience['bulletsb'] = experience['existing'];
  }

  if (typeof resume.parser === 'undefined') {
    resume.parser = [];
    resume.parser.push([]);
  }
  resume.parser[0].P1 = '';

  const newData = { resumes: resumes };
  stateProps.setDataToSave({ saved: newData, industry: stateProps.dataToSave.industry });

  resume.regenExpertise = true;
  resume.regenComputerSkills = true;
  stateProps.setSpinnerImage('');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
  updateSectionData({ sectionName: 'menu', parsed: true }, props.stateProps);
  save(stateProps, resumeIndex);
};

const hasParsedLetter = (uv) => {
  if (uv.resume['parse-letter'] === undefined) {
    return false;
  }
  if (uv.resume['parse-letter'][0]['PL6'] === undefined) {
    return false;
  }
  if (uv.resume['parse-letter'][0]['PL6'] === '') {
    return false;
  }
  return true;
};

export const parseCoverLetter = (props) => {
  const formData = new FormData();
  const uv = getUsefulVars(props);
  uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['job-posting'][0]['job_posting'] = uv.formikProps.values.jobSeekerData[0]['job_posting'];
  save(uv.stateProps,uv.resumeIndex);
  if (!hasParsedLetter(uv)) {
    const company_name = uv.resume['job-posting'][0]['name'];
    const company_address = uv.resume['job-posting'][0]['address'];
    const company_city = uv.resume['job-posting'][0]['city'];
    const company_state = uv.resume['job-posting'][0]['state'];
    const company_postal_code = uv.resume['job-posting'][0]['zip'];
    const target_industry = uv.resume['industry'][0];
    const target_role = uv.resume['job-posting'][0]['job_title'];
    const target_job_posting = uv.resume['job-posting'][0]['job_posting'];
    const experiences = uv.resume['professional-experience'];
    const career_profile = uv.resume['download'][0]['D1'];
    const educations = uv.resume['education'];
    let expertises = undefined;
    if (uv.resume['expertiseData'] !== undefined) {
      expertises = uv.resume['expertiseData'].options;
    }
    let resume = '';
    if (experiences !== undefined) {
      resume += '\nWork Experience\n';
      for (const experience of experiences) {
        if(experience['bulletsb'] === undefined) {
          experience['bulletsb'] = experience['existing'];
        }
        const bullets = experience['bulletsb'];

        resume += '\nIndustry: ' + experience['industry'] + '\n';
        resume += '\nJob Title: ' + experience['job_title'] + '\n';
        resume += '\nCompany Name: ' + experience['job_title'] + '\n';
        if (bullets !== undefined) {
          for (const bullet of bullets) {
            const compositedBullet = composeBullet(bullet);
            resume += '\n' + compositedBullet + '\n';
          }
        }
      }
    };

    resume += '\nSkills\n';
    if (expertises !== undefined) {
      for (const expertise of expertises) {
        resume += expertise.key;
      }
    }
    const url = uv.stateProps.domain + '/wp-json/rsworks/v1/parse_letter';
    const userID = uv.stateProps.userID;
    formData.append('userID', userID);
    formData.append('company_name', company_name);
    formData.append('career_profile', career_profile);
    formData.append('company_address', company_address);
    formData.append('company_city', company_city);
    formData.append('company_state', company_state);
    formData.append('company_postal_code', company_postal_code);
    formData.append('target_industry', target_industry);
    formData.append('target_job_title', target_role);
    formData.append('target_job_posting', target_job_posting);
    formData.append('resume', resume);
    formData.append('resume_index', uv.resumeIndex);
    const args = {
      props: props,
    };
    uv.stateProps.setSpinnerMessage('We\'re typing up your cover letter, which may take a few minutes.\n'
    + 'Need a coffee refill?');
    uv.stateProps.setSpinnerImage('parser.gif');
    uv.stateProps.onSpinnerOpen();

    runAxios(url, formData, parseLetterCallback, args);
  } else {
    onLink(false, uv.formikProps, uv.stateProps, 'preview-letter');
  }
};

export const parseResume = async (props) => {
  const formData = new FormData();
  const uv = getUsefulVars(props);

  const target_industry = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex].industry[0];
  const target_role = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['job_title'];

  const savedResumes = uv.formikProps.values.jobSeekerData[0];
  //create uniquish job id
  const jobID = Math.random().toString(36).substring(2, 15);

  //initial file checks before sending to server
  if (savedResumes.P2 === undefined || savedResumes.P2.size > 1000000) {
    if (savedResumes.P2 === undefined) {
      alert('Please select a resume before uploading.');
    } else {
      if (savedResumes.P2.size > 1000000) {
        alert('Resumes must be less than 1MB to parse.');
      }
    }
  } else {
    const url = uv.stateProps.domain + '/wp-json/rsworks/v1/parse_resume';
    const userID = uv.stateProps.userID;
    formData.append('parsed_resume', savedResumes.P2);
    formData.append('userID', userID);
    formData.append('jobID', jobID);
    formData.append('resumeIndex', uv.resumeIndex);
    formData.append('target_industry', target_industry);
    formData.append('target_role', target_role);

    const args = {
      props: props,
      userID:userID,
      jobID: jobID,
    };

    uv.stateProps.setSpinnerMessage('We\'re typing up your life story, which may take a few minutes.\n'
    + 'Need a coffee refill?');
    uv.stateProps.setSpinnerImage('parser.gif');
    uv.stateProps.onSpinnerOpen();

    try {
      const result = await runAxiosAsync(url, formData, args);
      const fileUploadError = handleFileUploadError(result,uv.stateProps,args)
      if(fileUploadError) {
        return;
      }
      if (result.status === 'processing') {
        // Axios timed out, start polling
        pollForParseResult(result.job_id, result.user_id, args);
      } else {
        // Server completed within timeout, process results
        parseResumePollCallback(result, args);
      }
    } catch (error) {
      handleParseError(error.message, args);
    }
  }
};

export const saveParse = (e, jobSeekerData, index, qObj, props) => {
  jobSeekerData[index][qObj.qid] = e.target.value;
  onSubmit(props.formikProps, props.stateProps);
};
